import * as React from "react";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import LooksThreeIcon from "@mui/icons-material/Looks3";
import LooksFourIcon from "@mui/icons-material/Looks4";
import LooksFiveIcon from "@mui/icons-material/Looks5";
import MDBox from "components/MDBox";

export default function MDTopThree({ position }) {
  return (
    <>
      {position === 1 && (
        <MDBox display="flex" flexDirection="column">
          <MDBox mb={-1.5}>
            <WorkspacePremiumIcon color="warning" fontSize="large" />
          </MDBox>
          <MDBox>
            <LooksOneIcon color="warning" fontSize="large" />
          </MDBox>
        </MDBox>
      )}
      {position === 2 && (
        <MDBox display="flex" flexDirection="column">
          <MDBox mb={-1.5}>
            <WorkspacePremiumIcon color="warning" fontSize="medium" />
          </MDBox>
          <MDBox>
            <LooksTwoIcon color="warning" fontSize="medium" />
          </MDBox>
        </MDBox>
      )}
      {position === 3 && (
        <MDBox display="flex" flexDirection="column">
          <MDBox mb={-1.5}>
            <WorkspacePremiumIcon color="warning" fontSize="small" />
          </MDBox>
          <MDBox>
            <LooksThreeIcon color="warning" fontSize="small" />
          </MDBox>
        </MDBox>
      )}
      {position === 4 && (
        <MDBox display="flex" flexDirection="column">
          <MDBox>
            <LooksFourIcon color="warning" fontSize="small" />
          </MDBox>
        </MDBox>
      )}
      {position === 5 && (
        <MDBox display="flex" flexDirection="column">
          <MDBox>
            <LooksFiveIcon color="warning" fontSize="small" />
          </MDBox>
        </MDBox>
      )}
    </>
  );
}
